const cf_const = {};
// Authoring設問種別
cf_const.auth = {};
cf_const.auth.QT_MULTIPLE_CHOICE = '1';
cf_const.auth.QT_TRUE_FALSE = '2';
cf_const.auth.QT_MULTIPLE_CORRECT = '3';
cf_const.auth.QT_FILL_IN_TYPING = '4';
cf_const.auth.QT_FILL_IN_INITIAL = '5';
cf_const.auth.QT_FILL_IN_POPUP = '6';
cf_const.auth.QT_ORDERING = '7';
cf_const.auth.QT_LOCATING = '8';
cf_const.auth.QT_INSERTION = '9';
cf_const.auth.QT_CLOZE = '10';
cf_const.auth.QT_READING = '11';
cf_const.auth.QT_LISTENING = '12';
cf_const.auth.QT_FILL_IN_MATCHING = '13';
cf_const.auth.QT_DICTATION = '14';
cf_const.auth.QT_YOUTUBE = '15';
cf_const.auth.QT_MULTIPLE_CHOICE_CN = '16';
cf_const.auth.QT_TRUE_FALSE_CN = '17';
cf_const.auth.QT_MULTIPLE_CORRECT_CN = '18';
cf_const.auth.QT_FILL_IN_POPUP_CN = '19';
cf_const.auth.QT_ORDERING_CN = '20';
cf_const.auth.QT_LOCATING_CN = '21';
cf_const.auth.QT_FILL_IN_MATCHING_CN = '22';
cf_const.auth.QT_FILL_IN_MATCHING_WORD = '23';
cf_const.auth.QT_OPEN_ENDED = '24';
cf_const.auth.QT_LISTAN = '25';
cf_const.auth.QT_SCANNING = '26';

cf_const.auth.BOOK_STATUS_NEW = '0';
cf_const.auth.BOOK_STATUS_DRAFT = '1';
cf_const.auth.BOOK_STATUS_COMPLETE = '2';

// Bookタイプ

// ドリル/テスト(PC)
cf_const.BOOKTYPE_DRILL_PC = 1;
// ドリル/テスト(スマホ)
cf_const.BOOKTYPE_DRILL_SM = 2;
// アンケート
cf_const.BOOKTYPE_QUESTIONNAIRE = 3;
// レポート
cf_const.BOOKTYPE_REPORT = 4;


export default cf_const;



// WEBPACK FOOTER //
// ./es6/admin-common-js/cf_const.js